import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS008KingakuInfoInVO,} from '@pages/sms008-kingaku-info/sms008-kingaku-info-in-vo';
import {SMS008KingakuInfoOutVO,} from '@pages/sms008-kingaku-info/sms008-kingaku-info-out-vo';
import * as Const_SMS008 from '@pages/sms008-kingaku-info/sms008-kingaku-info-const';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms008-kingaku-info',
  templateUrl: './sms008-kingaku-info.html',
  styleUrls: ['./sms008-kingaku-info.scss',],
})
/*****************************************************/
/* 処　理：SMS008 請求金額詳細 画面
/*
/* 概　要：詳細金額確認 処理
/* 　　　※SMS004：コンビニ収納サービス、SMS005：家賃残高・振込口座確認 画面から遷移する
/*
/* 更新日：2025/03/06 HARAGU 00011_SMS機能等の導入支援_#10082
/*****************************************************/
export class SMS008KingakuInfo implements OnInit {
  smsForm!: FormGroup;                  // 画面フォーム
  loginUserVO!: LoginUserVO;            // セッション情報
  sms008InfoVO!: SMS008KingakuInfoInVO; // POSTパラメータ
  dispId!: string;                      // ログ表示用ID
  lngType!: string;                     //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // 画面項目（ラベル入れ替え用）
  public lblYatinTotal!: string;
  public lblShutokuDate!: string;
  public lblBldgName!: string;
  public lblBtnBarcode!: string;
  public lblBtnKozaInfo!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  // 明細表示用
  public lblGankin: string[] = [];
  public lblHoshouItakuryou: string[] = [];
  public lblShunouTesuryo: string[] = [];
  public lblHoukatuHiyo: string[] = [];
  public lblShotanHokenryo: string[] = [];
  public lblTienSongaiKin: string[] = [];
  public lblSaiseikyuTesuryo: string[] = [];
  public lblSaikokuHiyoYusoCost: string[] = [];
  public lblSaikokuHiyoDocCost: string[] = [];
  public lblGoukeiGaku: string[] = [];

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00801M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }

    const postVo: SMS008KingakuInfoInVO = this.windowService.getItemFromLocalStorage<SMS008KingakuInfoInVO>('SMS008')!;
    if (postVo) {
      // POSTパラメータを取得
      this.sms008InfoVO = postVo;

    } else {

      // エラーログ出力
      this.logger.error('SMS00801M006E');

      // POSTパラメータが取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
    });

    // 初期表示
    this.formInit();
  }


  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00801M001I', this.dispId, Const_SMS008.INIT_NAME);

      // ログ出力（POSTパラメータ）
      this.logger.debug(this.dispId + ' ■ 08 POSTパラメータ');
      this.logger.debug(this.dispId + ' ■ 08  yatinYm  ：' + this.sms008InfoVO.yatinYm);

      // 初期表示API処理
      this.getInitData(Const_SMS008.API_INIT_PATH, Const_SMS008.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00801M002I', this.dispId, Const_SMS008.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00801M001E', this.dispId, Const_SMS008.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 08 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      yatinYm: this.sms008InfoVO.yatinYm,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 08 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 08 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 08 ApiIn   shouninNo    ：' + apiVo.shouninNo);
    this.logger.debug(this.dispId + ' ■ 08 ApiIn   yatinYm      ：' + apiVo.yatinYm);

    // 初期表示API
    this.logger.info('SMS00801M003I', this.dispId, btnName);
    this.httpClient.post<SMS008KingakuInfoOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00801M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00801M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00801M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 08 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS008KingakuInfoOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS008KingakuInfoOutVO): void {

    this.logger.debug(this.dispId + ' ■ 08 start-- getInitApiReturnInfo');

    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  goukeiGaku             ：' + resp['goukeiGaku']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  shutokuDate            ：' + resp['shutokuDate']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  bldgName               ：' + resp['bldgName']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  yatinYm                ：' + resp['yatinYm']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zGankin                ：' + resp['zGankin']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zHoshouItakuryou       ：' + resp['zHoshouItakuryou']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zHiyo                  ：' + resp['zHiyo']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zJimuTesuryo           ：' + resp['zJimuTesuryo']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zShotanHokenryo        ：' + resp['zShotanHokenryo']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zRisokuKingaku         ：' + resp['zRisokuKingaku']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zSaiseikyuTetudukiHiyo ：' + resp['zSaiseikyuTetudukiHiyo']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zSaikokuHiyo_docCost   ：' + resp['zSaikokuHiyo_docCost']);
    this.logger.debug(this.dispId + ' ■ 08 ApiOut  zSaikokuHiyo_yusoCost  ：' + resp['zSaikokuHiyo_yusoCost']);

    // {1} 円
    const yen = this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M001F',},  false) || '';

    // 画面文言（言語区分により変換）
    // 月額合計（{1} 円）
    this.lblYatinTotal = yen.replace('{1}', resp['goukeiGaku']);

    // 取得日付
    const sYy = resp['shutokuDate'].substring(0, 4);
    const sMm = resp['shutokuDate'].substring(4, 6);
    const sDd = resp['shutokuDate'].substring(6, 8);

    // 家賃年月
    const sYatinYy = resp['yatinYm'].substring(0, 4);
    const sYatinMm = resp['yatinYm'].substring(4, 6);

    //(取得日：{1}年{2}月{3}日)
    this.lblShutokuDate = (this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M002F',},  false) || '').replace('{1}', sYy).replace('{2}', sMm).replace('{3}', sDd);
    // {1}　賃料詳細
    this.lblBldgName = (this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M003F',},  false) || '').replace('{1}', resp['bldgName']);

    // 金額詳細-名称（インデックス-０）
    // {1}年{2}月元金
    this.lblGankin.push((this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M004F',},  false) || '').replace('{1}', sYatinYy).replace('{2}', sYatinMm));
    // 保証委託料・支払手数料
    this.lblHoshouItakuryou.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M005F',},  false) || '');
    // 収納手数料・決済サービス
    this.lblShunouTesuryo.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M006F',},  false) || '');
    // 包括費用
    this.lblHoukatuHiyo.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M007F',},  false) || '');
    // 少額短期保険
    this.lblShotanHokenryo.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M008F',},  false) || '');
    // 遅延損害金
    this.lblTienSongaiKin.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M009F',},  false) || '');
    // 再請求手数料
    this.lblSaiseikyuTesuryo.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M010F',},  false) || '');
    // 催告費用（書類作成代）
    this.lblSaikokuHiyoDocCost.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M011F',},  false) || '');
    // 催告費用（郵送代）
    this.lblSaikokuHiyoYusoCost.push(this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M012F',},  false) || '');
    this.lblGoukeiGaku.push('');

    // 金額詳細-値（インデックス-１）
    this.lblGankin.push(yen.replace('{1}', resp['zGankin']));
    this.lblHoshouItakuryou.push(yen.replace('{1}', resp['zHoshouItakuryou']));
    this.lblShunouTesuryo.push(yen.replace('{1}', resp['zHiyo']));
    this.lblHoukatuHiyo.push(yen.replace('{1}', resp['zJimuTesuryo']));
    this.lblShotanHokenryo.push(yen.replace('{1}', resp['zShotanHokenryo']));
    this.lblTienSongaiKin.push(yen.replace('{1}', resp['zRisokuKingaku']));
    this.lblSaiseikyuTesuryo.push(yen.replace('{1}', resp['zSaiseikyuTetudukiHiyo']));
    this.lblSaikokuHiyoDocCost.push(yen.replace('{1}', resp['zSaikokuHiyo_docCost']));
    this.lblSaikokuHiyoYusoCost.push(yen.replace('{1}', resp['zSaikokuHiyo_yusoCost']));
    this.lblGoukeiGaku.push(yen.replace('{1}', resp['goukeiGaku']));

    // コンビニ払いバーコード発行
    this.lblBtnBarcode = this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M013F',},  false) || '';
    // 家賃振込先表示へ
    this.lblBtnKozaInfo = this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M014F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M015F',},  false) || '';

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS008' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 08 end---- getInitApiReturnInfo');
    return;
  }


  /* **************************************************************
   * コンビニ払いバーコード発行ボタン押下
   * **************************************************************/
  barcodeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00801M005I', this.dispId, Const_SMS008.BTN_BARCODE_NAME);

      // 画面遷移
      this.nextPage('SMS004');

    } catch (ex) {
      this.logger.error('SMS00801M002E', this.dispId, Const_SMS008.BTN_BARCODE_NAME);
      this.commonException(ex);
    }
  }

  /* **************************************************************
   * 家賃振込先表示へボタン押下
   * **************************************************************/
  kozaInfoClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00801M005I', this.dispId, Const_SMS008.BTN_KOZAINFO_NAME);

      // 画面遷移
      this.nextPage('SMS005');

    } catch (ex) {
      this.logger.error('SMS00801M002E', this.dispId, Const_SMS008.BTN_KOZAINFO_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面遷移処理
   * @param {string} screenId 画面ID
   */
  nextPage(screenId: string): void{
    if ('SMS004' === screenId) {
      this.logger.debug(this.dispId + ' ■ 08 → 04 画面遷移');
      this.windowService.transit<null>('SMS004', null);   // ■ バーコード用リンク 画面へ
    } else {
      this.logger.debug(this.dispId + ' ■ 08 → 05 画面遷移');
      this.windowService.transit<null>('SMS005', null);   // ■ 家賃残高・口座の確認 画面へ
    }
  }

  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00801M005I', this.dispId, Const_SMS008.BTN_BACKMENU_NAME);

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00801M002E', this.dispId, Const_SMS008.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }


  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 08 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

}
